export default "__VITE_ASSET__k84BoMwD__"